// Code generated - EDITING IS FUTILE. DO NOT EDIT.

export interface Spec {
	id: string;
	version: string;
	url?: string;
	parentId?: string;
}

export const defaultSpec = (): Spec => ({
	id: "",
	version: "",
});

